<template>
  <DepartmentSearchPage />
</template>

<script>
import DepartmentSearchPage from '~contemporaryTheme/pages/departments/index'

export default {
  components: {
    DepartmentSearchPage,
  },
}
</script>
